import * as i0 from '@angular/core';
import { PLATFORM_ID, Component, SkipSelf, Optional, Host, Inject, Input, Output, ContentChildren, NgModule } from '@angular/core';
import DxValidator from 'devextreme/ui/validator';
import * as i1 from 'devextreme-angular/core';
import { DxComponentExtension, DxTemplateHost, WatcherHelper, NestedOptionHost, IterableDifferHelper, DxIntegrationModule, DxTemplateModule } from 'devextreme-angular/core';
import { DxiValidationRuleComponent, DxoAdapterModule, DxiValidationRuleModule } from 'devextreme-angular/ui/nested';
import { DxiValidatorAsyncRuleComponent, DxiValidatorCompareRuleComponent, DxiValidatorCustomRuleComponent, DxiValidatorEmailRuleComponent, DxiValidatorNumericRuleComponent, DxiValidatorPatternRuleComponent, DxiValidatorRangeRuleComponent, DxiValidatorRequiredRuleComponent, DxiValidatorStringLengthRuleComponent, DxiValidatorValidationRuleComponent, DxoValidatorAdapterModule, DxiValidatorAsyncRuleModule, DxiValidatorCompareRuleModule, DxiValidatorCustomRuleModule, DxiValidatorEmailRuleModule, DxiValidatorNumericRuleModule, DxiValidatorPatternRuleModule, DxiValidatorRangeRuleModule, DxiValidatorRequiredRuleModule, DxiValidatorStringLengthRuleModule, DxiValidatorValidationRuleModule } from 'devextreme-angular/ui/validator/nested';

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/**
 * A UI component that is used to validate the associated DevExtreme editors against the defined validation rules.

 */
let DxValidatorComponent = /*#__PURE__*/(() => {
  class DxValidatorComponent extends DxComponentExtension {
    _watcherHelper;
    _idh;
    instance = null;
    /**
     * An object that specifies what and when to validate, and how to apply the validation result.
    
     */
    get adapter() {
      return this._getOption('adapter');
    }
    set adapter(value) {
      this._setOption('adapter', value);
    }
    /**
     * Specifies the global attributes to be attached to the UI component&apos;s container element.
    
     */
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    /**
     * Specifies the UI component&apos;s height.
    
     */
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    /**
     * Specifies the editor name to be used in the validation default messages.
    
     */
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    /**
     * Specifies the validation group the editor will be related to.
    
     */
    get validationGroup() {
      return this._getOption('validationGroup');
    }
    set validationGroup(value) {
      this._setOption('validationGroup', value);
    }
    /**
     * An array of validation rules to be checked for the editor with which the dxValidator object is associated.
    
     */
    get validationRules() {
      return this._getOption('validationRules');
    }
    set validationRules(value) {
      this._setOption('validationRules', value);
    }
    /**
     * Specifies the UI component&apos;s width.
    
     */
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /**
    
     * A function that is executed before the UI component is disposed of.
    
    
     */
    onDisposing;
    /**
    
     * A function used in JavaScript frameworks to save the UI component instance.
    
    
     */
    onInitialized;
    /**
    
     * A function that is executed after a UI component property is changed.
    
    
     */
    onOptionChanged;
    /**
    
     * A function that is executed after a value is validated.
    
    
     */
    onValidated;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    adapterChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    elementAttrChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    heightChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    nameChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    validationGroupChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    validationRulesChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    widthChange;
    get asyncRulesChildren() {
      return this._getOption('validationRules');
    }
    set asyncRulesChildren(value) {
      this._setChildren('validationRules', value, 'DxiValidatorAsyncRuleComponent');
    }
    get compareRulesChildren() {
      return this._getOption('validationRules');
    }
    set compareRulesChildren(value) {
      this._setChildren('validationRules', value, 'DxiValidatorCompareRuleComponent');
    }
    get customRulesChildren() {
      return this._getOption('validationRules');
    }
    set customRulesChildren(value) {
      this._setChildren('validationRules', value, 'DxiValidatorCustomRuleComponent');
    }
    get emailRulesChildren() {
      return this._getOption('validationRules');
    }
    set emailRulesChildren(value) {
      this._setChildren('validationRules', value, 'DxiValidatorEmailRuleComponent');
    }
    get numericRulesChildren() {
      return this._getOption('validationRules');
    }
    set numericRulesChildren(value) {
      this._setChildren('validationRules', value, 'DxiValidatorNumericRuleComponent');
    }
    get patternRulesChildren() {
      return this._getOption('validationRules');
    }
    set patternRulesChildren(value) {
      this._setChildren('validationRules', value, 'DxiValidatorPatternRuleComponent');
    }
    get rangeRulesChildren() {
      return this._getOption('validationRules');
    }
    set rangeRulesChildren(value) {
      this._setChildren('validationRules', value, 'DxiValidatorRangeRuleComponent');
    }
    get requiredRulesChildren() {
      return this._getOption('validationRules');
    }
    set requiredRulesChildren(value) {
      this._setChildren('validationRules', value, 'DxiValidatorRequiredRuleComponent');
    }
    get stringLengthRulesChildren() {
      return this._getOption('validationRules');
    }
    set stringLengthRulesChildren(value) {
      this._setChildren('validationRules', value, 'DxiValidatorStringLengthRuleComponent');
    }
    get validationRulesChildren() {
      return this._getOption('validationRules');
    }
    set validationRulesChildren(value) {
      this._setChildren('validationRules', value, 'DxiValidatorValidationRuleComponent');
    }
    get validationRulesLegacyChildren() {
      return this._getOption('validationRules');
    }
    set validationRulesLegacyChildren(value) {
      this._setChildren('validationRules', value, 'DxiValidationRuleComponent');
    }
    parentElement;
    constructor(elementRef, ngZone, templateHost, _watcherHelper, _idh, parentOptionHost, optionHost, transferState, platformId) {
      super(elementRef, ngZone, templateHost, _watcherHelper, transferState, platformId);
      this._watcherHelper = _watcherHelper;
      this._idh = _idh;
      this._createEventEmitters([{
        subscribe: 'disposing',
        emit: 'onDisposing'
      }, {
        subscribe: 'initialized',
        emit: 'onInitialized'
      }, {
        subscribe: 'optionChanged',
        emit: 'onOptionChanged'
      }, {
        subscribe: 'validated',
        emit: 'onValidated'
      }, {
        emit: 'adapterChange'
      }, {
        emit: 'elementAttrChange'
      }, {
        emit: 'heightChange'
      }, {
        emit: 'nameChange'
      }, {
        emit: 'validationGroupChange'
      }, {
        emit: 'validationRulesChange'
      }, {
        emit: 'widthChange'
      }]);
      this.parentElement = this.getParentElement(parentOptionHost);
      this._idh.setHost(this);
      optionHost.setHost(this);
    }
    _createInstance(element, options) {
      if (this.parentElement) {
        return new DxValidator(this.parentElement, options);
      }
      return new DxValidator(element, options);
    }
    getParentElement(host) {
      if (host) {
        const parentHost = host.getHost();
        return parentHost.element.nativeElement;
      }
      return;
    }
    ngOnDestroy() {
      this._destroyWidget();
    }
    ngOnChanges(changes) {
      super.ngOnChanges(changes);
      this.setupChanges('validationRules', changes);
    }
    setupChanges(prop, changes) {
      if (!(prop in this._optionsToUpdate)) {
        this._idh.setup(prop, changes);
      }
    }
    ngDoCheck() {
      this._idh.doCheck('validationRules');
      this._watcherHelper.checkWatchers();
      super.ngDoCheck();
      super.clearChangedOptions();
    }
    _setOption(name, value) {
      let isSetup = this._idh.setupSingle(name, value);
      let isChanged = this._idh.getChanges(name, value) !== null;
      if (isSetup || isChanged) {
        super._setOption(name, value);
      }
    }
    /** @nocollapse */
    static ɵfac = function DxValidatorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxValidatorComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i1.DxTemplateHost), i0.ɵɵdirectiveInject(i1.WatcherHelper), i0.ɵɵdirectiveInject(i1.IterableDifferHelper), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 13), i0.ɵɵdirectiveInject(i1.NestedOptionHost), i0.ɵɵdirectiveInject(i0.TransferState), i0.ɵɵdirectiveInject(PLATFORM_ID));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxValidatorComponent,
      selectors: [["dx-validator"]],
      contentQueries: function DxValidatorComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, DxiValidatorAsyncRuleComponent, 4);
          i0.ɵɵcontentQuery(dirIndex, DxiValidatorCompareRuleComponent, 4);
          i0.ɵɵcontentQuery(dirIndex, DxiValidatorCustomRuleComponent, 4);
          i0.ɵɵcontentQuery(dirIndex, DxiValidatorEmailRuleComponent, 4);
          i0.ɵɵcontentQuery(dirIndex, DxiValidatorNumericRuleComponent, 4);
          i0.ɵɵcontentQuery(dirIndex, DxiValidatorPatternRuleComponent, 4);
          i0.ɵɵcontentQuery(dirIndex, DxiValidatorRangeRuleComponent, 4);
          i0.ɵɵcontentQuery(dirIndex, DxiValidatorRequiredRuleComponent, 4);
          i0.ɵɵcontentQuery(dirIndex, DxiValidatorStringLengthRuleComponent, 4);
          i0.ɵɵcontentQuery(dirIndex, DxiValidatorValidationRuleComponent, 4);
          i0.ɵɵcontentQuery(dirIndex, DxiValidationRuleComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.asyncRulesChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.compareRulesChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.customRulesChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.emailRulesChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.numericRulesChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.patternRulesChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rangeRulesChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.requiredRulesChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.stringLengthRulesChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.validationRulesChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.validationRulesLegacyChildren = _t);
        }
      },
      hostAttrs: ["ngSkipHydration", "true"],
      inputs: {
        adapter: "adapter",
        elementAttr: "elementAttr",
        height: "height",
        name: "name",
        validationGroup: "validationGroup",
        validationRules: "validationRules",
        width: "width"
      },
      outputs: {
        onDisposing: "onDisposing",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        onValidated: "onValidated",
        adapterChange: "adapterChange",
        elementAttrChange: "elementAttrChange",
        heightChange: "heightChange",
        nameChange: "nameChange",
        validationGroupChange: "validationGroupChange",
        validationRulesChange: "validationRulesChange",
        widthChange: "widthChange"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([DxTemplateHost, WatcherHelper, NestedOptionHost, IterableDifferHelper]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
      decls: 0,
      vars: 0,
      template: function DxValidatorComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxValidatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxValidatorModule = /*#__PURE__*/(() => {
  class DxValidatorModule {
    /** @nocollapse */static ɵfac = function DxValidatorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxValidatorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxValidatorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoAdapterModule, DxiValidationRuleModule, DxoValidatorAdapterModule, DxiValidatorAsyncRuleModule, DxiValidatorCompareRuleModule, DxiValidatorCustomRuleModule, DxiValidatorEmailRuleModule, DxiValidatorNumericRuleModule, DxiValidatorPatternRuleModule, DxiValidatorRangeRuleModule, DxiValidatorRequiredRuleModule, DxiValidatorStringLengthRuleModule, DxiValidatorValidationRuleModule, DxIntegrationModule, DxTemplateModule, DxoAdapterModule, DxiValidationRuleModule, DxoValidatorAdapterModule, DxiValidatorAsyncRuleModule, DxiValidatorCompareRuleModule, DxiValidatorCustomRuleModule, DxiValidatorEmailRuleModule, DxiValidatorNumericRuleModule, DxiValidatorPatternRuleModule, DxiValidatorRangeRuleModule, DxiValidatorRequiredRuleModule, DxiValidatorStringLengthRuleModule, DxiValidatorValidationRuleModule, DxTemplateModule]
    });
  }
  return DxValidatorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DxValidatorComponent, DxValidatorModule };
